import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    Box
} from '@chakra-ui/react';

function ImageModal({ imageSrc, isOpen, onClose }) {
    return (
        <ChakraProvider resetCSS={false}>
            <Modal isCentered isOpen={isOpen} onClose={onClose} size="2xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody p={0}>
                        <Box overflow="auto" maxHeight="90vh">
                            <img
                                src={`data:image/png;base64,${imageSrc}`}
                                alt="Full Size"
                                style={{ width: '100%', height: 'auto', display: 'block' }}
                            />
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </ChakraProvider>
    );
}

export default ImageModal;
